define('gumbo-js-client-lib/forms/liveData/LinescoreForm',{
	currentInning: null,
	inningState: null,
	inningHalf: null,
	innings: null,
	away: {
		id: null,
		runs: null,
		hits: null,
		errors: null
	},
	home: {
		id: null,
		runs: null,
		hits: null,
		errors: null
	},
	pitchers: {
		win: null,
		lose: null,
		save: null
	}
});
